module.exports = __webpack_public_path__ + "img/yaguangzhenxingdaiWu.min.4295bc3b.png";